import { Button, Intent } from '@blueprintjs/core';

interface LoadDataButtonProps {
  handleLoadData: () => void;
}
const LoadDataButton = ({ handleLoadData }: LoadDataButtonProps) => {
  return (
    <Button
      fill
      icon={'manually-entered-data'}
      intent={Intent.PRIMARY}
      onClick={handleLoadData}
    >
      Utilizar dados do último envio
    </Button>
  );
};

export default LoadDataButton;
